<div class="select-holder">
  <select (change)="selectOrder()" [(ngModel)]="filter">
    <option [ngValue]="undefined">{{'sortByDefault' | translate}}</option>
    @for (order of orderBy; track order) {
      <option [value]="order">{{order | translate}}</option>
    }
  </select>
</div>
